Vue.filter('importo', function (value) {
  if (!$.isNumeric(value)) return '';
  return parseFloat(value).number_format(2,',','.');
})

Vue.filter('number', function (value) {
  if (!$.isNumeric(value)) return '';
  return parseFloat(value).number_format(0,',','.');
})

Vue.filter('mydate', function (value,param,currentFormat) {
    if (typeof currentFormat === 'undefined' || !currentFormat) currentFormat = 'YYYY-MM-DD HH:ii:ss';
    if (!value) return ''
  return moment(value,currentFormat).locale('it').format(param);
})

Vue.filter('mytime', function (value,param,currentFormat) {
    if (typeof currentFormat === 'undefined' || !currentFormat) currentFormat = 'HH:ii:ss';
    if (!value) return ''
  return moment(value,currentFormat).locale('it').format(param);
})

Vue.filter('ucfirst', function (value,param) {
  if (!value) return ''
  return value.charAt(0).toUpperCase() + value.slice(1);
})

Vue.directive('click-outside', {
    bind(el, binding, vnode) {
        var vm = vnode.context;
        var callback = binding.value;

        el.clickOutsideEvent = function (event) {
            if (!(el == event.target || el.contains(event.target))) {
                return callback.call(vm, event);
            }
        };
        document.body.addEventListener('click', el.clickOutsideEvent);
    },
    unbind(el) {
        document.body.removeEventListener('click', el.clickOutsideEvent);
    }
});
